export const LOAD_STATISTICS = 'LOAD_STATISTICS'